<template>
  <div class="nav-bar" :class="defaultBg ? 'themeColor' : 'whiteBg'">
    <div class="back" @click="onClickLeft">
      <img v-if="defaultBg" src="../assets/images/back_white.png" alt="">
      <img v-else src="../assets/images/back_black.png" alt="">
    </div>
    <div class="title">{{ title }}</div>
    <div class="service" v-if="service" @click="servicePhone">客服</div>
  </div>
</template>
<script>
export default {
  name: "navbar",
  props: {
    service: {
      type: Boolean,
      default: false
    },
    defaultBg: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: "",
    },
    path: {
      type: String,
      default: "",
    },
  },
  methods: {
    onClickLeft() {
      if (this.path) {
        this.$router.push(this.path);
      } else if (window.history.length == 1) {
        this.$router.push('/');
      } else {
        this.$router.go(-1);
      }
    },
    servicePhone() {
      this.$post('/article/customerService').then((res) => {
        let newData = res.data.replaceAll(/<[^>]+>/g, "")
        window.location.href = 'tel://' + newData
      })
    }
  }
}
</script>
<style lang="less" scoped>
.nav-bar {
  height: 44px;
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;

  .back {
    position: absolute;
    left: 16px;

    img {
      width: 10px;
      height: 20px;
    }
  }

  .title {
    font-size: 18px;
  }

  .service {
    font-size: 15px;
    position: absolute;
    right: 16px;
  }
}

.whiteBg {
  background: #FFFFFF;
  color: #000000;
}

///deep/ .van-nav-bar {
//  border-bottom: none;
//
//
//  .van-icon {
//    color: #fff;
//    font-size: 24px;
//  }
//
//  .van-nav-bar__content {
//    background-color: #126AFC;
//
//    .van-nav-bar__title {
//      color: #fff;
//      font-size: 18px;
//    }
//  }
//}
</style>